import React from 'react'
import TopNav from './TopNav'
import { HOPE_CLINICS_FULL_NAME } from '../../constants/constant'
type Props = {
  children: React.ReactNode
  title: string
}

const Layout = ({ title, children }: Props) => {
  return (
    <>
      <title>{title} | EHACare Appointment</title>
      <meta charSet='utf-8' />
      <meta name='viewport' content='initial-scale=1.0, width=device-width' />
      <link rel='shortcut icon' href='/img/favicon-32x32.png' />

      <TopNav />
      <main className='main'>{children}</main>

      <footer className='App-footer'>copyright 2025 {HOPE_CLINICS_FULL_NAME}</footer>
    </>
  )
}
export default Layout
